export default "__VITE_PUBLIC_ASSET__067b32bf__"